import { GraphQLClient } from 'graphql-request'

// graphql-request v7 builds the request URL via `new URL(endpoint)`, which
// throws on a relative path. Use an absolute URL based on the current origin.
const endpoint = `${window.location.origin}/graphql`

// Single shared client. Auth header is attached once we have a JWT (Phase 2).
export const gqlClient = new GraphQLClient(endpoint, {
  credentials: 'same-origin',
})

export function setAuthToken(token: string | null) {
  if (token) {
    gqlClient.setHeader('Authorization', `Bearer ${token}`)
  } else {
    gqlClient.setHeader('Authorization', '')
  }
}
